// extracted by mini-css-extract-plugin
module.exports = {"facilityList":"PZ7bR5","tableWrapper":"_3JPjmD","scrollable":"_2cWCca","title":"N0SxOl","table":"TbWtlW","responsive":"_22sJ2x","data":"_2o18XC","pinned":"_9gbMuf"};